// Gets the value at path of object -- https://lodash.com/docs/4.17.1#get
import { get as getProperty } from 'lodash';

function propChanged(props, nextProps, path, value) {
  const current = getProperty(props, path);
  const next = getProperty(nextProps, path);

  if (value === undefined) {
    return current !== next;
  } else if (typeof value === 'function') {
    return current !== next && value(next);
  } else {
    return current !== next && next === value;
  }
}

propChanged.TRUTHY = v => !!v;

export default propChanged;
